<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.72 4H21.5C21.7761 4 22 4.22386 22 4.5V5C21.9928 5.82988 21.7687 6.64345 21.35 7.36L19 11.49C18.4915 12.404 17.5357 12.979 16.49 13H10.26C10.0439 12.9954 9.82904 12.9651 9.62 12.91L8.62 15H19.5C19.7761 15 20 15.2239 20 15.5V16.5C20 16.7761 19.7761 17 19.5 17H7C6.72633 17.0063 6.4704 16.865 6.33 16.63L6.11 16.25C5.99438 16.0275 5.99438 15.7625 6.11 15.54L7.97 11.84C7.86843 11.7327 7.77797 11.6155 7.7 11.49L3.42 4H2.5C2.22386 4 2 3.77614 2 3.5V2.5C2 2.22386 2.22386 2 2.5 2H3.42C4.13737 1.99715 4.80132 2.37873 5.16 3L5.72 4ZM8 18C6.89543 18 6 18.8954 6 20C6 21.1046 6.89543 22 8 22C9.10457 22 10 21.1046 10 20C10 18.8954 9.10457 18 8 18ZM20 20C20 21.1046 19.1046 22 18 22C16.8954 22 16 21.1046 16 20C16 18.8954 16.8954 18 18 18C19.1046 18 20 18.8954 20 20Z"
      :fill="completed ? 'white' : '#87929D'"
    />
  </svg>
</template>

<script>
export default {
  props: ["completed"]
};
</script>
